<div id="mdwg-messages-layout" class="ux-message"  
    [style.background-color]="msgBackgroundColor"
    [style.color]="msgFontColor"
    >
    
    {{messageText}}

</div>
